/* mBr "Spend $75, Save $10" helper: product-page label, per-item cart tags, progress + applied note */
(() => {
  if (window.mbrDealNotice) return;
  window.mbrDealNotice = true;

  const CFG = window.mbrDeal || {};
  if (!CFG.ids || (CFG.ends && Date.now() > Date.parse(CFG.ends))) return; /* deal over: show nothing */
  const DEAL = CFG.title || 'Spend $75, Save $10';
  const MIN = (CFG.min || 75) * 100;
  const URL = CFG.url || '/collections/spend-75-save-10';
  const IDS = new Set((CFG.ids || []).map(Number));
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (c) => '$' + (c / 100).toFixed(2);

  /* ---------- product page label ---------- */
  const productLabel = () => {
    if (!CFG.productId || document.querySelector('.mbr-deal-pdp')) return;
    const anchor = document.querySelector('.product__info-container [id^="price-"], .product__info-wrapper [id^="price-"], .product [id^="price-"]');
    if (!anchor) return;
    const inDeal = IDS.has(Number(CFG.productId));
    const el = document.createElement('div');
    el.className = 'mbr-deal-pdp ' + (inDeal ? 'is-in' : 'is-out');
    el.innerHTML = inDeal
      ? '✓ Part of the <a href="' + URL + '">Spend $75, Save $10</a> deal'
      : 'Not part of the <a href="' + URL + '">Spend $75, Save $10</a> deal';
    anchor.insertAdjacentElement('afterend', el);
  };

  /* ---------- cart ---------- */
  let cart = null;
  let last = '';
  let busy = false;

  const rowsFor = (scope) => {
    if (scope === 'drawer') return [...document.querySelectorAll('cart-drawer .cart-item')];
    return [...document.querySelectorAll('#main-cart-items .cart-item')];
  };

  const paintRows = (scope) => {
    rowsFor(scope).forEach((row, i) => {
      const item = cart.items[i];
      const details = row.querySelector('.cart-item__details');
      if (!item || !details) return;
      let tag = details.querySelector('.mbr-deal-tag');
      const out = !IDS.has(Number(item.product_id));
      if (!out) { if (tag) tag.remove(); return; }
      if (!tag) {
        tag = document.createElement('p');
        tag.className = 'mbr-deal-tag';
        tag.textContent = 'Not part of the $75 deal';
        details.appendChild(tag);
      }
    });
  };

  const paintNote = (anchor, html, cls) => {
    if (!anchor) return;
    const parent = anchor.parentElement;
    let box = parent.querySelector(':scope > .mbr-deal-note');
    if (!html) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('role', 'status');
      parent.insertBefore(box, anchor);
    }
    if (box.dataset.state !== cls) { box.className = 'mbr-deal-note ' + cls; box.innerHTML = html; box.dataset.state = cls; }
  };

  const paint = () => {
    if (!cart) return;
    const items = cart.items || [];
    const applied = items.some((i) => (i.line_level_discount_allocations || []).some((a) => ((a.discount_application || {}).title || '').trim().toLowerCase() === DEAL.toLowerCase()))
      || (cart.cart_level_discount_applications || []).some((a) => (a.title || '').trim().toLowerCase() === DEAL.toLowerCase());
    const dealSubtotal = items.filter((i) => IDS.has(Number(i.product_id))).reduce((s, i) => s + (i.original_line_price || i.line_price || 0), 0);
    const hasOutside = items.some((i) => !IDS.has(Number(i.product_id)));

    let html = '', cls = '';
    if (applied) {
      cls = 'is-applied';
      html = '<strong>🎉 Your "Spend $75, Save $10" deal is applied.</strong>' +
        '<span>Discount codes (like MBR10 or JOIN10) can’t be combined with this deal. At checkout you’ll automatically get whichever saves you more.</span>';
    } else if (items.length && dealSubtotal < MIN) {
      cls = 'is-progress';
      html = '<strong>You’re ' + money(MIN - dealSubtotal) + ' away from $10 off.</strong>' +
        '<span>Only <a href="' + URL + '">deal styles</a> count toward the $75' + (hasOutside ? ' (items marked “Not part of the $75 deal” don’t count)' : '') + '.</span>';
    }
    paintNote(document.querySelector('#main-cart-footer .mbr-sum .cart__ctas'), html, cls);
    paintNote(document.querySelector('cart-drawer .drawer__footer .cart__ctas'), html, cls);
    paintRows('page');
    paintRows('drawer');
  };

  const check = async () => {
    if (busy) return;
    busy = true;
    try {
      const c = await fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      const key = c.token + ':' + c.total_price + ':' + c.item_count + ':' + c.items.map((i) => i.key).join(',');
      if (key !== last) { last = key; cart = c; }
    } catch (e) { /* leave the cart as is */ }
    busy = false;
    paint();
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; check(); }, 250);
  };

  const start = () => {
    productLabel();
    check();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    const main = document.getElementById('MainContent');
    if (main && document.body.classList.contains('template-cart')) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('cart:updated', schedule);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
